export default function () {
    return [
        'জ্বর',
        'জ্বর জ্বর ভাব',
        'কাঁপুনি',
        'কাশি',
        'ক্লান্তি',
        'বমি',
        'হাত-পায়ে ব্যথা',
        'মাথা ব্যথা',
        'পেট ব্যথা',
        'গলা ব্যথা',
        'বুকে ব্যথা',
        'দাঁতে ব্যথা',
        'শ্বাসকষ্ঠ',
        'বমি ভাব',
        'পাতলা পায়খানা',
        'ঘুম হয়না',
        'খাবারে অরুচি',
        'ওজন কমা',
        'উচ্চ রক্তচাপ',
        'নিম্ন রক্তচাপ',
        'ডায়াবেটিক্স'
    ];
}
